import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { webApi, influencerApi } from '@/lib/api';
import { useNewInfluencerAuth } from '@/lib/config/apiFlags';

/**
 * 원본: .references/gc-mono/apps/gc-zoku/redux/modules/profile.js
 * 인플루언서 프로필 상태
 */

export interface UserProfile {
  _id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  country?: string;
  paypalEmail?: string;
  channels?: Array<{
    channelType: string;
    channelId: string;
    channelName: string;
    subscribers?: number;
  }>;
  [key: string]: unknown;
}

interface ProfileState {
  myProfile: UserProfile | null;
  loading: boolean;
  saving: boolean;
}

const initialState: ProfileState = {
  myProfile: null,
  loading: false,
  saving: false,
};

export const fetchMyProfile = createAsyncThunk(
  'profile/me/get',
  async () => useNewInfluencerAuth()
    ? influencerApi.post<UserProfile>('profile/me/get')
    : webApi.post<UserProfile>('profile/me/get'),
);

export const saveMyProfile = createAsyncThunk(
  'profile/me/save',
  async (params: Partial<UserProfile>) => useNewInfluencerAuth()
    ? influencerApi.post<UserProfile>('profile/me/save', params as Record<string, unknown>)
    : webApi.post<UserProfile>('profile/me/save', params as Record<string, unknown>),
);

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.myProfile = action.payload;
      })
      .addCase(fetchMyProfile.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveMyProfile.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveMyProfile.fulfilled, (state, action) => {
        state.saving = false;
        // 서버 응답이 일부 필드만 반환하는 경우가 있으므로 기존 프로필에 병합
        state.myProfile = { ...state.myProfile, ...action.payload } as UserProfile;
      })
      .addCase(saveMyProfile.rejected, (state) => {
        state.saving = false;
      });
  },
});

export default profileSlice.reducer;
